import { arSA, enUS, heIL, ruRU } from '@mui/material/locale';
import { createTheme } from "@mui/material/styles";
import { getDirectionByLanguage } from '../Helpers/Utils';
import { SecurityMonitor } from "../Security/XSSProtection";
import componentStyleOverrides from "./compStyleOverride";
import themePalette from "./palette";
import themeTypography from "./typography";

// Supported languages for security validation
const SUPPORTED_LANGUAGES = ['ar-SA', 'he-IL', 'en-US', 'ru-RU'];

const getLanguageProps = (choosen) => {
    // Validate language input
    if (typeof choosen !== 'string' || !SUPPORTED_LANGUAGES.includes(choosen)) {
        SecurityMonitor.reportViolation(
            'INVALID_LANGUAGE',
            `Invalid language selection: ${choosen}`,
            {
                severity: 'MEDIUM',
                language: choosen,
                timestamp: new Date().toISOString()
            }
        );

        // Default to English if invalid language provided
        choosen = 'en-US';
    }

    switch (choosen) {
        case 'ar-SA':
            return arSA;
        case 'he-IL':
            return heIL;
        case 'en-US':
            return enUS;
        case 'ru-RU':
            return ruRU;
        default:
            // This should never be reached due to validation above
            return enUS;
    }
}

const theme = (config, choosen) => {
    try {
        // Validate config is an object
        if (!config || typeof config !== 'object') {
            SecurityMonitor.reportViolation(
                'INVALID_THEME_CONFIG',
                'Invalid theme configuration provided',
                {
                    severity: 'HIGH',
                    config: typeof config,
                    timestamp: new Date().toISOString()
                }
            );
            config = {}; // Use default empty config
        }
        return createTheme({
            direction: getDirectionByLanguage(choosen),
            palette: themePalette(config),
            typography: themeTypography({}),
            components: componentStyleOverrides(config?.application?.theme, getDirectionByLanguage(choosen))
        }, getLanguageProps(choosen));
    } catch (error) {
        SecurityMonitor.reportViolation(
            'THEME_CREATION_ERROR',
            `Error creating theme: ${error.message}`,
            {
                severity: 'HIGH',
                error: error.toString(),
                config: config,
                language: choosen,
                timestamp: new Date().toISOString()
            }
        );

        // Return a basic safe theme
        return createTheme({
            direction: getDirectionByLanguage(choosen),
            palette: themePalette({}),
            typography: themeTypography({}),
            components: componentStyleOverrides({}, getDirectionByLanguage(choosen))
        }, getLanguageProps(choosen));
    }
};

export default theme